import { z } from "zod";
import {
  serUint8ArraySchema,
  serUint16ArraySchema,
  serFloat32ArraySchema,
  deserializeArrayRecord,
  serializeArrayRecord,
} from "../serialization";

const previewResponseErrorSchema = z.object({
  $status: z.literal("error"),
  $code: z.literal("NOT_FOUND").optional(),
  error: z.string(),
});

export const previewResponseSuccessDataSchema = z.object({
  xyz: serUint16ArraySchema,
  rgb: serUint8ArraySchema,
  offset: serFloat32ArraySchema,
});
export type PreviewResponseSuccessData = z.infer<
  typeof previewResponseSuccessDataSchema
>;

const previewResponseSuccessSchema = z.object({
  $status: z.literal("success"),
  data: previewResponseSuccessDataSchema,
});
type PreviewResponseSuccess = z.infer<typeof previewResponseSuccessSchema>;

export const previewResponseSchema = z.discriminatedUnion("$status", [
  previewResponseErrorSchema,
  previewResponseSuccessSchema,
]);
export type PreviewResponse = z.infer<typeof previewResponseSchema>;

export function serializePreviewSuccessResponse(data: {
  xyz: Uint16Array;
  rgb: Uint8Array;
  offset: Float32Array;
}) {
  return serializeArrayRecord<typeof data>(data);
}

export function deserializePreviewSuccessResponse(
  data: PreviewResponseSuccess
) {
  return deserializeArrayRecord<{
    xyz: Uint16Array;
    rgb: Uint8Array;
    offset: Float32Array;
  }>(data.data);
}

export const previewRequestSchema = z.object({
  id: z.string(),
  lod: z.number().int().min(0).max(2),
});
export type PreviewRequest = z.infer<typeof previewRequestSchema>;
